// extracted by mini-css-extract-plugin
export var DarkModeIconOff = "style-module--DarkModeIconOff--8cd93";
export var DarkModeIconOn = "style-module--DarkModeIconOn--0e98a";